const convertPhoneNumber = (match) => ({
  type: "phone",
  text: match[0],
  num: match[1],
});
const r = (regex) => {
  // create regex match function
  return (...args) => regex.exec(...args);
};

const matchPhoneNumber = (value) => {
  // matches any number:
  // starting with +
  // 11 - 13 numbers
  // might contain - ( ) as separators

  if (value.indexOf("+") !== 0) return null;

  let betweenChars = 0;
  const numberOut = [];
  const textOut = ["+"];

  // eslint-disable-next-line no-useless-escape
  let myRe = /^([0-9\-\(\) ])/;
  let lastIndex = 1; // skip +

  let match;
  while ((match = myRe.exec(value.slice(lastIndex))) !== null) {
    lastIndex += 1;

    let c = match[0];
    if (/[0-9]/.test(c)) {
      betweenChars = 0;
      numberOut.push(c);
    } else {
      betweenChars += 1;
    }

    textOut.push(c);

    if (betweenChars > 2) {
      break;
    }
  }

  if (numberOut.length < 11 || numberOut.length > 13) {
    return null;
  }

  const num = numberOut.join("");
  const text = textOut.slice(0, textOut.length - betweenChars).join("");

  return [text, num];
};

const PARSERS = [
  [
    // match user tag
    // eslint-disable-next-line no-useless-escape
    r(/^@\[([^\@|\[|\]|\(|\)]*?)\]\(([0-9a-f]+)\)/),
    (match) => ({
      type: "usertag",
      text: match[0],
      name: match[1],
      humanId: match[2],
    }),
  ],
  [
    // match tag
    r(/^#([0-9a-z\-_()]+)/i),
    (match) => ({ type: "tag", text: match[0], tag: match[1] }),
  ],
  [matchPhoneNumber, convertPhoneNumber],
  [
    // match word + whitespace
    r(/^(.*?)(\s+|$)/i),
    (match) => match[0],
  ],
];

/**
 * @param {string} input
 * @return {Array}
 */
export default function parse(input) {
  const out = [];

  let lastIndex = 0;

  while (lastIndex < input.length) {
    for (const p of PARSERS) {
      const [parseFn, convertFn] = p;

      const match = parseFn(input.slice(lastIndex));

      if (!match) continue;

      lastIndex += match[0].length;

      out.push(convertFn(match));

      break;
    }
  }

  return out;
}
